const categories = {
  common: [
    {
      id: 1,
      title: 'Market analytics',
      href: '#',
    },
    {
      id: 2,
      title: 'New in Cirrusoft',
      href: '#',
    },
    {
      id: 3,
      title: 'Future of retail',
      href: '#',
    },
    {
      id: 4,
      title: 'Data management',
      href: '#',
    },
    {
      id: 5,
      title: 'Market analytics',
      href: '#',
    },
  ],
  popular: [
    {
      id: 1,
      title: '# automation',
      href: '#',
    },
    {
      id: 2,
      title: '# AI',
      href: '#',
    },
    {
      id: 3,
      title: '# automationl',
      href: '#',
    },
    {
      id: 4,
      title: '# future',
      href: '#',
    },
    {
      id: 5,
      title: '# future',
      href: '#',
    },
  ],
};

export default categories;
